import * as React from "react";

export const Home = () => <>home</>;
export default Home;
